import { useSelector } from 'react-redux';
import usePlatformAgentState from '../context/usePlatformAgentState';
import useIntercomVisible from '../utility/useIntercomVisible';

// The bottom-right row (Ask Amigo, Intercom's companion): 20 px from the window's bottom, 48 px tall, and 12 px of air
// above it (design: Button). Tailwind needs a literal class, so the room is spelled out; a test holds it to this.
export const PLATFORM_AGENT_ROW_ROOM = 20 + 48 + 12;
export const PLATFORM_AGENT_PAGE_ROOM = 'pb-[80px] lg:pb-[80px]';

/**
 * Room at the bottom of the page's content while the bottom-right row shows (QA92), so the last rows of a table or a
 * form scroll clear of Ask Amigo and Intercom instead of hiding a link under them. Not on a page with a bar fixed to
 * its bottom (useBottomBar): the row sits above that bar, and the page's content ends above it already.
 * Returns the class for the page's scroll area, or '' without the row.
 */
export default function usePlatformAgentPageRoom() {
  const { available, launcher } = usePlatformAgentState();
  const open = useSelector((state) => state.platformAgent.open);
  const bottomBar = useSelector((state) => state.platformAgent.bottomBar);
  const intercomVisible = useIntercomVisible();

  // As PlatformAgent draws it: Ask Amigo while the panel is closed, Intercom's companion whenever Intercom is on.
  const rowShows = (available && !open) || ((available || launcher) && intercomVisible);

  return rowShows && !bottomBar ? PLATFORM_AGENT_PAGE_ROOM : '';
}
